module.exports = __webpack_public_path__ + "img/dialog-omni-bg.f42e0fa5.png";